import React, { useState } from 'react';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Tooltip } from '@mui/material';
import {
  gridRowSelectionCountSelector,
  ToolbarButton,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-premium';
import { scGray15, scPurple75, scPurple80 } from 'constants/systemColors';

import { DefaultToolbar } from 'components/MUIDataGrid/DefaultToolbar/DefaultToolbar';
import { CustomViews } from 'components/pages/patient-source/PmWorkbook/PMWorkbookTable/TableComponents/CustomViews/CustomViews';

export const PatientDatabaseToolbar = ({
  onPushToPreScreening,
  refreshData,
  defaultTableState,
  columns,
  columnGroupingModel,
  tableVersion,
  tableName,
  ...restProps
}) => {
  const [quickFilterExpanded, setQuickFilterExpanded] = useState(false);
  const apiRef = useGridApiContext();
  const selectedRowCount = useGridSelector(apiRef, gridRowSelectionCountSelector);
  const pushToPreScreeningDisabled = selectedRowCount === 0;

  return (
    <DefaultToolbar
      {...restProps}
      quickFilterProps={{ expanded: quickFilterExpanded, onExpandedChange: setQuickFilterExpanded }}
      startContent={
        onPushToPreScreening && (
          <Button
            variant="contained"
            size="small"
            startIcon={<PlaylistAddIcon />}
            onClick={onPushToPreScreening}
            disabled={pushToPreScreeningDisabled}
            data-testid="push-to-pre-screening-btn"
            sx={{
              backgroundColor: scPurple80,
              '&:hover': { backgroundColor: scPurple75 },
              '&.Mui-disabled': {
                backgroundColor: scGray15
              },
              textTransform: 'none'
            }}
          >
            Push To Pre-Screening
          </Button>
        )
      }
    >
      <Tooltip title="Refresh">
        <ToolbarButton onClick={refreshData} data-testid="refresh-table-button">
          <RefreshIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
      {defaultTableState && (
        <CustomViews
          defaultTableState={defaultTableState}
          columnGroupingModel={columnGroupingModel}
          columns={columns}
          tableVersion={tableVersion}
          tableName={tableName}
          setQuickFilterExpanded={setQuickFilterExpanded}
        />
      )}
    </DefaultToolbar>
  );
};
